import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import "./attachments.scss";
import { ProcessContext } from "../../ProcessLayoutWrapper";
import { useSelector } from "react-redux";
import AttachmentTable from "./AttachmentTable";
import TemporaryNotification from "~/components/toast-notification/AttachmentTemporaryNotification";
import DocumentConfirmationDialog from "~/components/confirmation-dialog/DocumentConfirmationDialog";
import AttachmentSuccess from "~/components/toast-notification/AttachmentSuccess";

import apiService from "~/services/service";
import API_ROUTES from "~/api-routes";
import {
  getFilenameFromReference,
  getPayslipBlobName,
} from "~/utils/fileUtils";
import { useParams } from "react-router-dom";
import Config from "~/config/env";
import BlobFilter from "~/components/BlobFilter";
import FilterChip from "~/components/FilterChip";
import useAttachmentFilter from "~/hooks/useAttachmentFilter";

const ProcessAttachments = () => {
  const {
    formatDate,
    fetchProcessAttachments,
    statesAttachment,
    handleDeleteDocument,
    handleConfirmDeleteDocumment,
    handleRestoreDocument,
    setStatesAttachment,
    paySlipMatchingResult,
    loading,
    handleDeletePayslip,
    handleUndoPayslip,
    milestones,
    fetchReleasedPayslips,
    selectedItems,
    filterData,
    setFilterData,
    removeFnRef,
    handleRemoveFilter,
    handleFilterChange,
    filterLoading,
    onSortOrderChange,
    allData,
    filterPageChange,
    currentPage,
  } = useContext(ProcessContext);
  const { id } = useParams();
  const storageAccount = Config.BLOB_STORAGE_ACCOUNT;
  const { processAttachments, loadingAttachments } = useSelector(
    (state) => state.attachments,
  );
  const { processdata } = useSelector((state) => state.process);
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(0);
  const [first, setFirst] = useState(0);

  const onPageChange = (e) => {
    setRows(e.rows);
    setFirst(e.first);
  };

  useEffect(() => {
    if (processdata?.id) {
      fetchProcessAttachments();
    }
    fetchReleasedPayslips();
  }, [processdata?.id]);
  const attachmentData = useMemo(() => {
    if (!paySlipMatchingResult && !processAttachments) return [];
    const task =
      milestones?.filter((data) => data?.name === "Submit Final Output") ?? [];
    const owner = task[0]?.taskData?.find(
      (task) => task.name === "Submit final output to Customer",
    )?.owner;

    const payslipData =
      paySlipMatchingResult?.map((data) => ({
        name: getPayslipBlobName(data?.blobName) || data?.original_file_name,
        original_file_name: data.source_filename || data?.original_file_name,
        file_type: "application/pdf",
        blob_url: `https://${storageAccount}.blob.core.windows.net/${"ess"}/${data?.blobName}`,
        createdByData: {
          first_name: data?.createdByData?.first_name,
          last_name: data?.createdByData?.last_name,
          email: data?.createdByData?.email,
        },
        createdAt: data?.createdAt,
        size: data?.size,
        isPayslipData: true,
        id: data?.id,
        created_by: data?.userData?.id,
        owner: owner?.toUpperCase(),
        category: "PAYSLIPS_AND_PAYROLL_REPORTS",
        subCategory: "PAYSLIPS",
      })) ?? [];

    return [...payslipData, ...(processAttachments ?? [])].sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    );
  }, [paySlipMatchingResult, processAttachments, milestones]);

  return (
    <>
      {statesAttachment?.temporaryMessage && (
        <TemporaryNotification
          onUndo={
            statesAttachment?.selectedFile?.isPayslipData
              ? handleUndoPayslip
              : handleRestoreDocument
          }
          setMessages={(value) =>
            setStatesAttachment((prev) => ({
              ...prev,
              temporaryMessage: value,
            }))
          }
          successMsg={statesAttachment?.temporaryMessage}
        />
      )}

      {statesAttachment?.restoreMessage && (
        <AttachmentSuccess
          successMsg={statesAttachment?.restoreMessage}
          setMessages={(value) =>
            setStatesAttachment((prev) => ({ ...prev, restoreMessage: value }))
          }
        />
      )}
      <div className="flex flex-row-reverse mb-2">
        <BlobFilter
          onApply={({ value, group }) => {
            setFilterData(value);
          }}
          onRemove={(fn) => (removeFnRef.current = fn)}
          onFilterChange={({ value, grouped }) => {
            handleFilterChange(grouped);
          }}
          showEntity={false}
          showServiceLine={false}
          showYears={false}
          disabled={!attachmentData?.length}
          serviceLine={processdata?.serviceData?.name}
        />
      </div>
      <div className="mb-2">
        <FilterChip
          filterData={filterData}
          removeFilter={(id) => {
            handleRemoveFilter(id);
          }}
        />
      </div>

      <AttachmentTable
        first={selectedItems.length ? currentPage : first}
        rows={rows}
        onPageChange={
          selectedItems.length
            ? (e) => {
                filterPageChange(e.page + 1);
              }
            : onPageChange
        }
        formatDate={formatDate}
        processAttachments={selectedItems.length ? allData : attachmentData}
        loadingAttachments={
          selectedItems.length ? filterLoading : loadingAttachments || loading
        }
        handleAttachmentDelete={handleDeleteDocument}
        attachmentConfirmModal={statesAttachment?.attachmentConfirmModal}
        setAttachmentConfirmModal={(value) =>
          setStatesAttachment((prev) => ({
            ...prev,
            attachmentConfirmModal: false,
          }))
        }
        isAttachmentLoader={statesAttachment?.isAttachmentLoader}
        relatedType="PROCESS"
        relatedId={id}
        onSortOrderChange={
          selectedItems?.length ? onSortOrderChange : undefined
        }
        isFilterApplied={selectedItems.length}
        totalRecords={
          selectedItems.length ? allData.length : attachmentData?.length
        }
        onRefetch={fetchProcessAttachments}
      />
      {statesAttachment?.attachmentConfirmModal && (
        <DocumentConfirmationDialog
          visible={statesAttachment?.attachmentConfirmModal}
          closeModal={(value) =>
            setStatesAttachment((prev) => ({
              ...prev,
              attachmentConfirmModal: false,
            }))
          }
          handleSave={
            statesAttachment?.selectedFile?.isPayslipData
              ? handleDeletePayslip
              : handleConfirmDeleteDocumment
          }
          isLoader={statesAttachment?.isAttachmentLoader}
        />
      )}
    </>
  );
};

export default ProcessAttachments;
